'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/2/16.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDates = require('react-dates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import moment from 'moment';

var GoeasyDateRangePicker = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GoeasyDateRangePicker, _Component);

  function GoeasyDateRangePicker(props) {
    (0, _classCallCheck3.default)(this, GoeasyDateRangePicker);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GoeasyDateRangePicker).call(this, props));

    _this.state = {
      focusedInput: null
      // startDate: null,
      //  endDate: null
    };
    return _this;
  }

  (0, _createClass3.default)(GoeasyDateRangePicker, [{
    key: 'onDatesChange',
    value: function onDatesChange(_ref) {
      var startDate = _ref.startDate;
      var endDate = _ref.endDate;
      var dateChange = this.props.dateChange;

      if (dateChange) {
        dateChange({ startDate: startDate, endDate: endDate });
      }
    }
  }, {
    key: 'onFocusChange',
    value: function onFocusChange(focusedInput) {
      this.setState({ focusedInput: focusedInput });
    }
  }, {
    key: 'render',
    value: function render() {
      var focusedInput = this.state.focusedInput;

      return _react2.default.createElement(_reactDates.DateRangePicker, (0, _extends3.default)({}, this.props, {
        onDatesChange: this.onDatesChange.bind(this),
        onFocusChange: this.onFocusChange.bind(this),
        focusedInput: focusedInput
      }));
    }
  }]);
  return GoeasyDateRangePicker;
}(_react.Component), _class.propTypes = {
  dateChange: _react.PropTypes.func,
  focusChange: _react.PropTypes.func
}, _temp);
exports.default = GoeasyDateRangePicker;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyDatePicker/GoeasyDateRangePicker.js
 ** module id = 1340
 ** module chunks = 0
 **/